module.exports = __webpack_public_path__ + "fonts/Merriweather-300-latin-ext10.00e97a0.woff2";